const selectBase = state => state.inAppCards.openState

export const selectSidebarCardOpenState = (state, key) => {
  const states = selectBase(state)
  return states[key]
}
